// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"bc3e81f3","141":"e21e0f00","235":"3c86ba72","353":"d046488b","395":"5318eb89","453":"78f4b8a3","522":"c8d20b69","671":"a9066aaf","683":"dee4d4d9","731":"427b3afe","810":"12f52bd0","827":"7a2a8a38","885":"a7ab54ff"}[chunkId] + ".chunk.js";
};